import * as React from 'react';
import { Refinements } from '@packages/common';

interface RefinementsContextValue {
  refinements: Refinements;
  setRefinements: React.Dispatch<React.SetStateAction<Refinements>>;
}

export const RefinementsContext = React.createContext({} as RefinementsContextValue);

interface RefinementsContextProviderProps {
  initialRefinements: Refinements;
  categoryId?: string;
}

export const RefinementsProvider: React.FC<RefinementsContextProviderProps> = ({
  children,
  initialRefinements,
  categoryId = '',
}) => {
  const [refinementsState, setRefinementsState] = React.useState(initialRefinements);
  // this makes sure refinementsState gets updated when refinements passed from
  // outside change (for example when the user goes to another category)
  // keep categoryId and initialRefinements?query in the dep array to keep track of changes
  React.useEffect(() => {
    setRefinementsState(initialRefinements);
  }, [initialRefinements, categoryId, initialRefinements?.query]);

  return (
    <RefinementsContext.Provider
      value={{
        refinements: refinementsState,
        setRefinements: setRefinementsState,
      }}
    >
      {children}
    </RefinementsContext.Provider>
  );
};
